import Auction from "../interfaces/Auction";

export default function getAuctionsAvailableUntil(auction: Auction) : Date {
    const availableUntil = new Date(auction.created_at);
    const createdAt = new Date(auction.created_at);
    availableUntil.setMinutes(createdAt.getMinutes() + auction.duration)
    return availableUntil;
}